import cx from "classnames";
import React from "react";

import { Props } from "@/mk2/apps/forum/containers/ForumSearch/ForumSearchPage";
import { Img } from "@/mk2/components/Img";
import { SearchBox } from "@/mk2/components/SearchBox";
import {
    SEARCH_IN_FORUM,
    SEARCH_RESULTS_FOR,
    YOU_DID_NOT_ENTER_SEARCH_TEXT,
} from "@/mk/autogenerated/translation";
import assetUrl from "@/mk/common/assetUrl";
import { ACTIVE_SERVER_ID, GCSE_CX } from "@/mk/settings";

import styles from "./ForumSearch.mscss";

const IMG_HORSEY_WITH_MAGNIFIER = `${assetUrl}img/stickers/${ACTIVE_SERVER_ID}/40.png`;

declare const google;
declare const _googCsa;

class ForumSearch extends React.Component<Props> {
    private results: HTMLDivElement;
    private gname = "forum-results";

    public componentDidMount() {
        const { queryFromUrl, queryFromState, onSearchUpdate, onSearchSave } = this.props;

        // Save search on the server
        if (queryFromUrl && queryFromUrl !== queryFromState) {
            onSearchUpdate(queryFromUrl);
        } else if (queryFromUrl) {
            onSearchSave(queryFromUrl);
        }

        // Mount cse
        const scripttag = document.querySelector("script#cse");
        if (!scripttag) {
            (window as any).__gcse = {
                parsetags: "explicit",
                callback: this.renderResults,
            };

            const gcse: HTMLScriptElement = document.createElement("script");
            gcse.id = "cse";
            gcse.type = "text/javascript";
            gcse.async = true;
            gcse.src = "https://cse.google.com/cse.js?cx=" + GCSE_CX;
            const s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(gcse, s);

            const gcsa1: HTMLScriptElement = document.createElement("script");
            gcsa1.async = true;
            gcsa1.src = "https://www.google.com/adsense/search/ads.js";
            s.parentNode.insertBefore(gcsa1, s);

            const gcsa2: HTMLScriptElement = document.createElement("script");
            gcsa2.type = "text/javascript";
            gcsa2.text =
                "(function(g,o){g[o]=g[o]||function(){(g[o]['q']=g[o]['q']||[]).push(\n" +
                "  arguments)},g[o]['t']=1*new Date})(window,'_googCsa');";
            s.parentNode.insertBefore(gcsa2, s);
        } else {
            this.renderResults();
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const { queryFromState, queryFromUrl, onSearchUpdate, onSearchSave } = this.props;

        if (queryFromUrl !== prevProps.queryFromUrl) {
            if (queryFromUrl !== queryFromState) {
                onSearchUpdate(queryFromUrl);
            } else {
                if (queryFromUrl) {
                    onSearchSave(queryFromUrl);
                }

                this.updateResults();
            }
        }
    }

    public componentWillUnmount() {
        // Clear search in the state
        const { onSearchUpdate } = this.props;
        onSearchUpdate("");
    }

    public render() {
        const { className, queryFromState, queryFromUrl, onSearchUpdate } = this.props;

        return (
            <div className={cx(styles.ForumSearch, className)}>
                <SearchBox
                    query={queryFromState}
                    placeholder={SEARCH_IN_FORUM}
                    onChange={onSearchUpdate}
                    onSubmit={this.handleOnSearch}
                    autoFocus="end"
                    noClear
                />
                {queryFromUrl ? (
                    <h2 className={styles.ForumSearch__headline}>
                        {SEARCH_RESULTS_FOR} <span>&ldquo;{queryFromUrl}&rdquo;</span>
                    </h2>
                ) : (
                    <>
                        <Img
                            width={160}
                            height={114}
                            src={IMG_HORSEY_WITH_MAGNIFIER}
                            className={styles.ForumSearch__img}
                            alt="search icon"
                        />
                        <h2 className={styles.ForumSearch__headline}>
                            {YOU_DID_NOT_ENTER_SEARCH_TEXT}
                        </h2>
                    </>
                )}

                <div id="afscontainer1" className={styles.ForumSearch__searchAdsAndShoppingAds} />

                <div
                    className={cx(
                        styles.ForumSearch__results,
                        !queryFromUrl && styles["ForumSearch__results--empty"],
                    )}
                    ref={(r) => (this.results = r)}
                />
            </div>
        );
    }

    private handleOnSearch = (searchQuery: string) => {
        const { onSearch, location } = this.props;
        onSearch(searchQuery, location);
    };

    private renderResults = () => {
        if (typeof google === "undefined") {
            // cse is not loaded yet
            return;
        }

        if (document.readyState === "complete") {
            this.gcseRender();
        } else {
            google.setOnLoadCallback(this.gcseRender);
        }
    };

    private updateResults = () => {
        // Custom Search Engine script is loaded
        if (typeof google !== "undefined") {
            const { queryFromUrl } = this.props;
            const element = google.search.cse.element.getElement(this.gname);
            if (element && element.getInputQuery() !== queryFromUrl) {
                if (queryFromUrl) {
                    element.execute(queryFromUrl);
                } else {
                    element.clearAllResults();
                }
            }
        }

        // Custom Search Ads script is loaded
        if (typeof _googCsa !== "undefined") {
            const { queryFromUrl } = this.props;
            if (queryFromUrl) {
                const pageOptions = {
                    pubId: "partner-pub-8317032171613030",
                    styleId: "6461056092",
                    query: queryFromUrl,
                };
                const adblock1 = {
                    container: "afscontainer1",
                };
                _googCsa("ads", pageOptions, adblock1);
            }
        }
    };

    private gcseRender = () => {
        google.search.cse.element.render({
            div: this.results,
            tag: "searchresults-only",
            gname: this.gname,
        });
        this.updateResults();
    };
}

export default ForumSearch;
